import { apiURL } from 'config/api';
import request from 'utils/request';

export default function validateUserEmail(email: string, validateEdu = false): Promise<void> {
  return request.post(apiURL.validateEmail, { body: { email, validateEdu } });
}
